export default "/fonts/vendor/katex/dist/KaTeX_Fraktur-Regular.woff2?172d3529b26f8cedef6b5ddef7546e02";